import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Tooltip } from "shared/atoms/Tooltip";
import { BLUE, GREEN, RED } from "theme/colors";

interface WidgetBoxToolbarProps {
  adherenceDiff: number | null;
  adherencePercentage: number | null;
  filterEmptyDays: boolean;
  setFilterEmptyDays: React.Dispatch<React.SetStateAction<boolean>>;
}

export const WidgetBoxToolbar: React.FC<WidgetBoxToolbarProps> = ({
  adherenceDiff,
  adherencePercentage,
  filterEmptyDays,
  setFilterEmptyDays,
}) => {
  const { t } = useTranslation();
  const sign = adherenceDiff !== null && adherenceDiff >= 0 ? "+" : "";

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "baseline" }}>
      <Tooltip
        title={
          filterEmptyDays
            ? t("patients.adherence_graph.show_empty_days")
            : t("patients.adherence_graph.hide_empty_days")
        }
        placement="top"
        arrow
      >
        <IconButton onClick={() => setFilterEmptyDays(prev => !prev)} size="small">
          <FontAwesomeIcon icon={filterEmptyDays ? faEye : faEyeSlash} color={BLUE[100]} />
        </IconButton>
      </Tooltip>
      <Stack alignItems="flex-end">
        <Typography variant="h2">
          {adherencePercentage !== null ? `${Math.round(adherencePercentage)}%` : "—"}
        </Typography>
        <Typography variant="label_bold" color={getDiffColor(adherenceDiff)}>
          {adherenceDiff !== null ? `${sign}${adherenceDiff.toFixed(1)}%` : "—"}
        </Typography>
      </Stack>
    </Stack>
  );
};

function getDiffColor(diff: number | null) {
  if (diff === null) return "text.primary";
  return diff >= 0 ? GREEN[100] : RED[100];
}
